export default {
  partnerList: '/v3/vehicle/rescue/partner/list',
  jumpInfo: '/v3/vehicle/rescue/jump/info'
}
